export const date = 'MM/dd/yyyy'
export const dateWithTime = `${date} hh:mm a`
export const timeFormat = 'hh:mm a'
export const newDateFormat = 'LLL dd, yyyy'
